namespace TabAurous.Inventory {
    export interface LotCreationRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        AutoPosting?: boolean;
        VoucherNo?: string;
        UserId?: number;
        EmployeeId?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        Details?: LotCreationDetailsRow[];
        CommonItemDetails?: LotCreationItemsRow[];
        PostingDate?: string;
        IsPosted?: boolean;
        Username?: string;
    }

    export namespace LotCreationRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.LotCreation';
        export const deletePermission = 'Inventory:LotCreation:Delete';
        export const insertPermission = 'Inventory:LotCreation:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:LotCreation:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            AutoPosting = "AutoPosting",
            VoucherNo = "VoucherNo",
            UserId = "UserId",
            EmployeeId = "EmployeeId",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            Details = "Details",
            CommonItemDetails = "CommonItemDetails",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            Username = "Username"
        }
    }
}
